module.exports = __webpack_public_path__ + "img/entry-image-xs-en.639d45aa.png";